module.exports = __webpack_public_path__ + "eye.14b14135.svg";